import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/shared/utils/request";

export interface SandboxProf {
	sandboxProfId: string;
	fullName: string;
	realProfId: string;
}

export function useSandboxProvision(realProfId: string | null) {
	const { makeApiRequest } = useApi();

	const query = useQuery({
		queryKey: ["sandbox", "provision", realProfId] as const,
		enabled: !!realProfId,
		staleTime: Infinity,
		gcTime: Infinity,
		retry: 1,
		queryFn: async () => {
			const res = await makeApiRequest({
				endpoint: "/sandbox/provision",
				method: "POST",
				body: { realProfId },
			});
			if (res.error) throw new Error(String(res.error));
			return res.data as SandboxProf;
		},
	});

	return {
		sandbox: query.data ?? null,
		isProvisioning: query.isLoading,
		error: query.error?.message ?? null,
	};
}
